import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import { DefaultCoverage, DupInsuranceProductType, PersonCoverage } from "../../../interfaces/dup";
import { ModelState } from "../../../interfaces/modelState";
import { getFullName } from "../../../lib/nameUtil";
import { InsuredAmounts, PersonalDetailsModel } from "../../../providers/dupFlow/DupFlow.interfaces";
import styles from "../../../style/layout_components/Step1.module.scss";
import DupVariantCoverage from "./DupVariantCoverage";

interface Props {
  fields: Record<string, Field<string>>;
  index: number;
  updateInsuredCoverage: (value: PersonCoverage, isApplied: boolean) => void;
  updateInsuredCoverageInsuranceType: (value: DupInsuranceProductType) => void;
  updateInsuredCoverageInsuredAmount: (value: number) => void;
  modelState: ModelState | null;
  setModelState: (modelState: ModelState) => void;
  insured: Partial<PersonalDetailsModel>;
  defaultCoverage: Partial<DefaultCoverage>;
  hasMultipleInsuredPersons: boolean;
  insuredAmounts: InsuredAmounts;
}

export const DupInsuredSummary = ({
  index,
  insured,
  defaultCoverage,
  fields,
  modelState,
  setModelState,
  insuredAmounts,
  hasMultipleInsuredPersons,
  updateInsuredCoverage,
  updateInsuredCoverageInsuranceType,
  updateInsuredCoverageInsuredAmount,
}: Props) => {
  const [expand, setExpand] = useState(false);
  const toggleExpand = () => {
    setExpand(!expand);
  };
  const variantCoverageLabel =
    !insured.isDefault && insured.isApplied ? fields.VariantCoverageNameLabel : fields.DefaultCoverageNameLabel;

  if (insured.dateOfBirth === undefined || insured.firstName === undefined) {
    return null;
  }

  const fullName = getFullName(insured);
  const name = fullName === `(${insured.firstName})` ? insured.firstName : fullName;

  return (
    <>
      <tr className={expand ? styles.coverageToggleIsOpen : undefined}>
        <td>
          <span>
            <i className="icon-persoon"></i>
            {name}
          </span>
          <span>{insured.dateOfBirth}</span>
        </td>
        <td>
          {insured.isDefault && hasMultipleInsuredPersons && (
            <span>
              <Text field={fields.DefaultCoverageNameLabel}></Text>
            </span>
          )}
          {!insured.isDefault && (
            <span
              id={`expand_${index}`}
              className={expand ? styles.coverageSpanIsOpen : styles.coverageSpan}
              onClick={toggleExpand}
            >
              {variantCoverageLabel.value}
            </span>
          )}
        </td>
      </tr>
      {!insured.isDefault && expand && (
        <DupVariantCoverage
          data={insured.personCoverage}
          defaultCoverage={defaultCoverage}
          expand={expand}
          setExpand={setExpand}
          fieldData={fields}
          index={index}
          modelState={modelState}
          setModelState={setModelState}
          insuredAmounts={insuredAmounts}
          updateInsuredCoverage={updateInsuredCoverage}
          updateInsuredCoverageInsuranceType={updateInsuredCoverageInsuranceType}
          updateInsuredCoverageInsuredAmount={updateInsuredCoverageInsuredAmount}
        />
      )}
    </>
  );
};
